import { Spin, message, Modal, Button, Tag, Divider, Space } from "antd";
import React, { useState, useEffect } from "react";
import {
  CloseOutlined,
  EyeOutlined,
  CalculatorOutlined,
  FileExcelOutlined,
} from "@ant-design/icons";
import axios from "axios";
import dayjs from "dayjs";
import {
  GET_CALUATE_HISTORY,
  GET_PROFIT_BY_CONTNO,
  HEADERS_EXPORT_DETAIL,
  POST_CALUATE_CONTNO,
} from "../../../API/apiUrls";
import CurrencyFormat from "../../../../hook/CurrencyFormat";
import IRRDetail from "./IRRDetail";
import ManualIRR from "./ManualIRR";

// ── Main SearchContno Modal ────────────────────────────────────
const SearchContno = ({ open, close, contno }) => {
  const [, , currencyFormatPoint] = CurrencyFormat();

  const [loading, setLoading] = useState(false);
  const [arrProfit, setArrProfit] = useState(null);
  const [arrHistory, setArrHistory] = useState([]);
  const [isModalIRRDtail, setIsModalIRRDtail] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [isModalIRRManaul, setIsModalIRRManaul] = useState(false);

  useEffect(() => {
    if (open && contno) queryData();
  }, [open, contno]);

  const queryData = async () => {
    setLoading(true);
    try {
      const [resProfit, resHistory] = await Promise.all([
        axios.get(GET_PROFIT_BY_CONTNO + contno, {
          headers: HEADERS_EXPORT_DETAIL,
        }),
        axios.get(GET_CALUATE_HISTORY + contno, {
          headers: HEADERS_EXPORT_DETAIL,
        }),
      ]);
      console.log("resProfit", resProfit);
      console.log("resHistory", resHistory);

      setArrProfit(resProfit.data ?? null);
      setArrHistory(resHistory.data ?? []);
    } catch (err) {
      message.error(
        err?.response?.status === 404 ? "ไม่พบข้อมูล" : "เกิดข้อผิดพลาด",
      );
    } finally {
      setLoading(false);
    }
  };

  const postSave = async () => {
    setLoading(true);
    try {
      const { data } = await axios.post(
        POST_CALUATE_CONTNO,
        { contract_no: contno },
        { headers: HEADERS_EXPORT_DETAIL },
      );

      message.success("บันทึกสำเร็จ");
      queryData();
      return data;
    } catch (error) {
      const status = error?.response?.status;
      const serverMsg =
        error?.response?.data?.message ??
        error?.response?.data?.error ??
        error.message;

      const errorMap = {
        400: `ข้อมูลไม่ถูกต้อง: ${serverMsg}`,
        401: "session หมดอายุ กรุณาเข้าสู่ระบบใหม่",
        404: "ไม่พบปลายทาง (404)",
        500: "เกิดข้อผิดพลาดจากเซิร์ฟเวอร์ (500)",
      };

      message.error(
        errorMap[status] ??
          `ไม่สามารถส่งข้อมูลได้${status ? ` (${status})` : ""}: ${serverMsg}`,
      );

      console.error("❌ postSave error:", { status, serverMsg, error });
    } finally {
      setLoading(false); // ✅ ย้ายมา finally — ทำงานทั้ง success และ error
    }
  };

  // ── คำนวณ warning ──────────────────────────────────────────
  const principal = arrProfit?.principal ?? 0;
  const monthly_payment = arrProfit?.monthly_payment ?? 0;
  const total_months = arrProfit?.total_months ?? 0;
  const totalInstallment = monthly_payment * total_months;
  const shortage = principal - totalInstallment;
  const targetInterest = principal * 0.15;
  console.log("arrProfit", arrProfit);
  console.log("arrHistory", arrHistory);

  return (
    <>
      <Modal
        title={
          <span style={{ fontSize: 16 }}>
            ตารางการคำนวณ IRR{" "}
            <span style={{ color: "#5b6ef5", fontWeight: 800 }}>{contno}</span>
          </span>
        }
        open={open}
        onCancel={close}
        width="82%"
        style={{ top: 20 }}
        footer={[
          <Button key="close" onClick={close} icon={<CloseOutlined />}>
            ปิด
          </Button>,
        ]}
      >
        <Spin spinning={loading} size="large" tip="กำลังโหลดข้อมูล...">
          {/* ── Contract Info Card ─────────────────────────────── */}
          {arrProfit && (
            <div
              style={{
                border: "1px solid #e8ecf5",
                borderRadius: 14,
                padding: "20px 24px",
                marginBottom: 20,
                background: "#fff",
                boxShadow: "0 2px 12px rgba(91,110,245,0.06)",
              }}
            >
              {/* Header */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 18,
                }}
              >
                <div
                  style={{ fontSize: 18, fontWeight: 700, color: "#1a1a2e" }}
                >
                  ข้อมูลสัญญา:{" "}
                  <span style={{ color: "#5b6ef5" }}>
                    {arrProfit.contract_no ?? contno}
                  </span>
                </div>
                <Tag
                  color="success"
                  style={{
                    fontSize: 13,
                    padding: "3px 14px",
                    borderRadius: 20,
                  }}
                >
                  พบข้อมูล
                </Tag>
              </div>

              {/* Grid ข้อมูล */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(3, 1fr)",
                  gap: "14px 0",
                  background: "#f8f9fc",
                  borderRadius: 10,
                  padding: "16px 20px",
                }}
              >
                {[
                  { label: "เงินต้น", value: currencyFormatPoint(principal) },
                  {
                    label: "ค่างวด",
                    value: currencyFormatPoint(monthly_payment),
                  },
                  { label: "จำนวนงวด", value: `${total_months} งวด` },
                  {
                    label: "วันเริ่มจ่าย",
                    value: dayjs(arrProfit.first_pay_date).format(
                      "DD MMM YYYY",
                    ),
                  },
                  {
                    label: "วันสุดท้าย",
                    value: dayjs(arrProfit.last_pay_date).format("DD MMM YYYY"),
                  },
                ].map((item, i) => (
                  <div key={i}>
                    <div
                      style={{
                        fontSize: 11,
                        color: "#aaa",
                        marginBottom: 4,
                        textTransform: "uppercase",
                        letterSpacing: "0.3px",
                      }}
                    >
                      {item.label}
                    </div>
                    <div
                      style={{
                        fontSize: 20,
                        fontWeight: 700,
                        color: "#2c3e50",
                      }}
                    >
                      {item.value}
                    </div>
                  </div>
                ))}
              </div>

              {/* Warning Box */}
              {shortage > 0 && (
                <div
                  style={{
                    marginTop: 16,
                    background: "#eef1ff",
                    border: "1px solid #d0d8fa",
                    borderRadius: 10,
                    padding: "14px 18px",
                  }}
                >
                  <div
                    style={{
                      color: "#4a54c4",
                      fontSize: 13,
                      marginBottom: 5,
                      fontWeight: 600,
                    }}
                  >
                    ℹ️ ค่างวดรวม{" "}
                    <span style={{ color: "#e05c00", fontWeight: 700 }}>
                      {currencyFormatPoint(totalInstallment)}
                    </span>{" "}
                    น้อยกว่าเงินต้น (ขาดอีก{" "}
                    <span style={{ color: "#c0392b", fontWeight: 700 }}>
                      {currencyFormatPoint(shortage)}
                    </span>
                    )
                  </div>
                  <div style={{ color: "#555", fontSize: 13 }}>
                    เป้าหมายดอกเบี้ยที่ระบบคำนวณอัตโนมัติ:{" "}
                    <strong style={{ color: "#5b6ef5", fontSize: 16 }}>
                      {currencyFormatPoint(targetInterest)}
                    </strong>{" "}
                    <span style={{ color: "#888" }}>
                      (ใช้เกณฑ์: กฎ 15% ของเงินต้น)
                    </span>
                  </div>
                </div>
              )}

              {/* ปุ่มคำนวณ */}
              <div style={{ marginTop: 20, textAlign: "center" }}>
                <Space size={12}>
                  {/* ── คำนวณและบันทึก ── */}
                  <Button
                    type="primary"
                    size="large"
                    icon={<CalculatorOutlined />}
                    style={{
                      background: "#5b6ef5",
                      border: "none",
                      borderRadius: 10,
                      padding: "0 36px",
                      height: 46,
                      fontSize: 15,
                      fontWeight: 600,
                      boxShadow: "0 4px 14px rgba(91,110,245,0.35)",
                    }}
                    onClick={() => postSave()}
                  >
                    คำนวณและบันทึก
                  </Button>

                  {/* ── สูตรการคำนวณ ── */}
                  <Button
                    size="large"
                    icon={<FileExcelOutlined />}
                    style={{
                      background: "#fff",
                      border: "1.5px solid #5b6ef5",
                      borderRadius: 10,
                      padding: "0 36px",
                      height: 46,
                      fontSize: 15,
                      fontWeight: 600,
                      color: "#5b6ef5",
                      boxShadow: "0 2px 8px rgba(91,110,245,0.12)",
                    }}
                    onClick={() => {
                      setIsModalIRRManaul(true);
                    }}
                  >
                    สูตรการคำนวณ
                  </Button>
                </Space>
              </div>
            </div>
          )}

          {/* ── History List ───────────────────────────────────── */}
          <div>
            <Divider
              style={{
                fontSize: 16,
                fontWeight: 700,
                marginBottom: 14,
                color: "#1a1a2e",
              }}
            >
              ประวัติการคำนวณ (History)
            </Divider>

            {arrHistory.length === 0 && !loading && (
              <div
                style={{
                  textAlign: "center",
                  color: "#bbb",
                  padding: "40px 0",
                  fontSize: 14,
                }}
              >
                ไม่พบประวัติการคำนวณ
              </div>
            )}

            {arrHistory.map((record, i) => (
              <div
                key={record.id ?? i}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  border: "1px solid #eef0f8",
                  borderRadius: 10,
                  padding: "14px 20px",
                  marginBottom: 10,
                  background: "#fff",
                  transition: "box-shadow 0.2s",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.boxShadow =
                    "0 2px 12px rgba(91,110,245,0.1)")
                }
                onMouseLeave={(e) => (e.currentTarget.style.boxShadow = "none")}
              >
                <div>
                  <div
                    style={{
                      fontWeight: 700,
                      color: "#2c3e50",
                      fontSize: 14,
                      marginBottom: 4,
                    }}
                  >
                    วันที่คำนวณ:{" "}
                    {dayjs(record.created_at).format("DD MMM YYYY HH:mm")}
                  </div>
                  <div style={{ fontSize: 12, color: "#999" }}>
                    Effective Rate:{" "}
                    <span style={{ color: "#2ecc71", fontWeight: 600 }}>
                      {record.effective_rate}%
                    </span>
                    {"  |  "}
                    Total Interest:{" "}
                    <span style={{ color: "#5b6ef5", fontWeight: 600 }}>
                      {currencyFormatPoint(record.total_interest_paid)}
                    </span>
                    {"  |  "}
                    Flat Rate:{" "}
                    <span style={{ color: "#3498db", fontWeight: 600 }}>
                      {record.flat_rate}%
                    </span>
                  </div>
                </div>
                <Button
                  type="link"
                  icon={<EyeOutlined />}
                  style={{ color: "#5b6ef5", fontWeight: 700, fontSize: 13 }}
                  onClick={() => {
                    console.log();
                    setSelectedRecord(record);
                    setIsModalIRRDtail(true);
                  }}
                >
                  ดูรายละเอียด →
                </Button>
              </div>
            ))}
          </div>
        </Spin>
      </Modal>
      {isModalIRRDtail && (
        <IRRDetail
          open={isModalIRRDtail}
          close={() => setIsModalIRRDtail(false)}
          record={selectedRecord}
        />
      )}
      {isModalIRRManaul && (
        <ManualIRR
          open={isModalIRRManaul}
          close={() => setIsModalIRRManaul(false)}
          record={arrProfit}
        />
      )}
    </>
  );
};

export default SearchContno;
